/**
 * Archive Deal Server Function
 *
 * Archives an existing deal (soft delete functionality).
 */

import { createServerFn } from "@tanstack/react-start";
import { logInfo, logError } from "@/lib/structured-log";

// Import API functions when they become available
// import { archiveDealApiWorkspacesWorkspaceIdDealsDealIdArchivePost } from "@/lib/api/generated";

interface DeleteDealRequest {
  workspaceId: string;
  dealId: string;
}

export const deleteDealServer = createServerFn()
  .validator((data: DeleteDealRequest) => data)
  .handler(async ({ data }) => {
    const { workspaceId, dealId } = data;

    try {
      logInfo("deal.delete.started", {
        dealId,
        workspaceId,
      });

      // TODO: Implement actual API call when backend endpoint is available
      // const response = await archiveDealApiWorkspacesWorkspaceIdDealsDealIdArchivePost({
      //   path: {
      //     workspace_id: workspaceId,
      //     deal_id: dealId,
      //   },
      // });

      // For now, simulate a successful deletion
      await new Promise((resolve) => setTimeout(resolve, 500));

      logInfo("deal.delete.completed", {
        dealId,
        workspaceId,
      });

      return {
        success: true,
        message: "Deal deleted successfully",
      };
    } catch (error) {
      logError("deal.delete.failed", {
        dealId,
        workspaceId,
        error: error instanceof Error ? error.message : String(error),
      });

      throw new Error(error instanceof Error ? error.message : "Failed to delete deal");
    }
  });
